exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1FGCIDN0s2EoDeNJbbAkg0{float:left;line-height:1.8;padding-right:1rem;width:100%}._1FGCIDN0s2EoDeNJbbAkg0:after{background:#ccc;content:\"\";display:block;height:.07143rem;left:0;position:absolute;width:100%}._2EJTRPJb3fu3Lg2R-ANOr5{color:#b4b4b4;font-size:.95em;font-weight:400;margin:0}.f0FZssV8hEi-X_va9a9Z7{border-bottom:.07143rem solid transparent;font-size:1rem;margin:0;padding-bottom:.57143rem;white-space:pre-line}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ReadOnlyField_board": "_1FGCIDN0s2EoDeNJbbAkg0",
	"ReadOnlyField_h5": "_2EJTRPJb3fu3Lg2R-ANOr5",
	"ReadOnlyField_p": "f0FZssV8hEi-X_va9a9Z7"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/Dashboard/GroupDetail/ReadOnlyField/style.postcss
// module id = 1242
// module chunks = 0